/* eslint-disable angular/timeout-service,angular/window-service,angular/log,angular/definedundefined,angular/angularelement */
'use strict';

function checkMobile(){
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

function checkMobileApple(){
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

/* function added for all device touch that are not identified in checkMobile or checkMobileApple */
function checkTouchDevice(){
    var touchDevice = 'ontouchstart' in document.documentElement;
    var touchWindow =('ontouchstart' in window);
    var IEBrowser = navigator.maxTouchPoints;
    return touchDevice || touchWindow || IEBrowser;
}

//
// This is a modified version of the jQuery context menu plugin. Credits below.
//

// jQuery Context Menu Plugin
//
// Version 1.01
//
// Cory S.N. LaViska
// A Beautiful Site (http://abeautifulsite.net/)
//
// More info: http://abeautifulsite.net/2008/09/jquery-context-menu-plugin/
//
// Terms of Use
//
// This plugin is dual-licensed under the GNU General Public License
//   and the MIT License and is copyright A Beautiful Site, LLC.
//
//
// noinspection SpellCheckingInspection
window.gemssMapGlobals = {
    DEFAULT_FONT_FAMILY: 'Open Sans',
    DEFAULT_FONT_SIZE: '19px',
    FONT_TO_FONT_FAMILY: {
        'Arial': 'Arial, Helvetica Neue, Helvetica, sans-serif',
        'Arial Rounded MT': 'Arial Rounded MT Bold, Helvetica Rounded, Arial, sans-serif',
        'Baskerville Old Face': 'Baskerville, Baskerville Old Face, Hoefler Text, Garamond, Times New Roman, serif',
        'Bodoni MT': 'Bodoni MT, Didot, Didot LT STD, Hoefler Text, Garamond, Times New Roman, serif',
        'Book Antiqua': 'Book Antiqua, Palatino, Palatino Linotype, Palatino LT STD, Georgia, serif',
        'Brush Script MT': 'Brush Script MT", cursive',
        'Calibri': 'Calibri, Candara, Segoe, Segoe UI, Optima, Arial, sans-serif',
        'Calisto MT': 'Calisto MT, Bookman Old Style, Bookman, Goudy Old Style, Garamond, Hoefler Text, Bitstream Charter, Georgia, serif,',
        'Cambria': 'Cambria, Georgia, serif',
        'Candara': 'Candara, Calibri, Segoe, Segoe UI, Optima, Arial, sans-serif',
        'Century Gothic': 'Century Gothic, CenturyGothic, AppleGothic, sans-serif',
        'Consolas': 'Consolas, monaco, monospace',
        'Courier New': 'Courier New, Courier, Lucida Sans Typewriter, Lucida Typewriter, monospace',
        'Franklin Gothic': 'Franklin Gothic Medium, Franklin Gothic, ITC Franklin Gothic, Arial, sans-serif',
        'Garamond': 'Garamond, Baskerville, Baskerville Old Face, Hoefler Text, Times New Roman, serif',
        'Georgia': 'Georgia, Times, Times New Roman, serif',
        'Gill Sans': 'Gill Sans, Gill Sans MT, Calibri, sans-serif',
        'Gill Sans MT': 'Gill Sans MT, Calibri, sans-serif',
        'Goudy Old Style': 'Goudy Old Style, Garamond, Big Caslon, Times New Roman, serif',
        'Impact': 'Impact,Haettenschweiler,Franklin Gothic Bold,Charcoal,Helvetica Inserat,Bitstream Vera Sans Bold,Arial Black,sans serif',
        'Lucida Bright': 'Lucida Bright, Georgia, serif',
        'Lucida Console': 'Lucida Console, Lucida Sans Typewriter, monaco, Bitstream Vera Sans Mono, monospace',
        'Lucida Sans Typewriter': 'Lucida Sans Typewriter, Lucida Console, monaco, Bitstream Vera Sans Mono, monospace',
        'Microsoft Sans Serif': 'sans-serif',
        'Palatino Linotype': 'Palatino Linotype, Palatino LT STD, Book Antiqua, Georgia, serif',
        'Papyrus': 'Papyrus, fantasy',
        'Perpetua': 'Perpetua, Baskerville, Big Caslon, Palatino Linotype, Palatino, URW Palladio L, Nimbus Roman No9 L, serif',
        'Perpetua Titling MT': 'Perpetua, Baskerville, Big Caslon, Palatino Linotype, Palatino, URW Palladio L, Nimbus Roman No9 L, serif',
        'Rockwell': 'Rockwell, Courier Bold, Courier, Georgia, Times, Times New Roman, serif',
        'Segoe UI': 'Segoe UI, Frutiger, Frutiger Linotype, Dejavu Sans, Helvetica Neue, Arial, sans-serif',
        'Tahoma': 'Tahoma, Verdana, Segoe, sans-serif',
        'Trebuchet MS': 'Trebuchet MS, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Tahoma, sans-serif',
        'Verdana': 'Verdana, Geneva, sans-serif'
    }
};

(function($){
    // noinspection JSUnusedGlobalSymbols
    $.extend($.fn,
        {
            contextMenu: function(options){
                // Defaults
                var defaults = { fadeIn: 150, fadeOut: 10 };
                var o = $.extend(true, defaults, options || {});
                var docElem = $(document);
                // Loop each context menu
                $(this).each(function(){
                    var el = $(this);
                    var offset = el.offset();
                    var $m = $('#' + o.menu);
                    // Add contextMenu class
                    $m.addClass('contextMenu');
                    // Simulate a true right click
                    $(this).mousedown(function(e){
                        // e.stopPropagation(); // Terry: No, thank you
                        $(this).mouseup(function(e){
                            console.log('mouse up received after mouse down', e);
                            // e.stopPropagation(); // Terry: No, thank you
                            var target = $(this);
                            target.unbind('mouseup');
                            if(e.button === 0) {
                                var allowPrevent = true;
                                var allowStopPropagation = true;
                                if(checkMobileApple()) {
                                    allowPrevent = o.allowPreventDefaultWhenAppleMobile;
                                    allowStopPropagation = o.allowStopPropagationWhenAppleMobile;
                                }
                                if(allowPrevent) { e.preventDefault(); }
                                if(allowStopPropagation) { e.stopPropagation(); }
                                if(o.onClick) {
                                   o.onClick();
                                }
                            }
                            if(e.button === 2){
                                // Hide context menus that may be showing
                                $('.contextMenu').hide();
                                // Get this context menu
                                if(el.hasClass('disabled')){
                                    return false;
                                }
                                // show context menu on mouse coordinates or keep it within visible window area
                                var x = Math.min(e.pageX, docElem.width() - $m.width() - 5);
                                console.log(options);
                                var parent=$('stand-alone-maps');
                                if(!parent.length){
                                    parent=$('gemssmap');
                                }
                                var menuYOffset=options.menuOffset?parent.position().top:0;
                                var y = Math.min(e.pageY, docElem.height() - $m.height() - 5);
                                y=y-menuYOffset;
                                // Show the menu
                                docElem.unbind('click');
                                $m.css({ top: y, left: x }).fadeIn(o.fadeIn)
                                    .find('A')
                                    .mouseover(function(){
                                        $m.find('LI.hover').removeClass('hover');
                                        $(this).parent().addClass('hover');
                                    })
                                    .mouseout(function(){
                                        $m.find('LI.hover').removeClass('hover');
                                    });
                                if(o.onShow){
                                    o.onShow(this, { x: x - offset.left, y: y - offset.top, docX: x, docY: y });
                                }
                                // Keyboard
                                docElem.keypress(function(e){
                                    var $hover = $m.find('li.hover');
                                    var $first = $m.find('li:first');
                                    var $last = $m.find('li:last');
                                    switch(e.keyCode){
                                        case 38:// up
                                            if($hover.size() === 0){
                                                $last.addClass('hover');
                                            }else{
                                                $hover.removeClass('hover').prevAll('LI:not(.disabled)').eq(0).addClass('hover');
                                                if($hover.size() === 0){
                                                    last.addClass('hover');
                                                }
                                            }
                                            break;
                                        case 40:// down
                                            if($hover.size() === 0){
                                                $first.addClass('hover');
                                            }else{
                                                $hover.removeClass('hover').nextAll('LI:not(.disabled)').eq(0).addClass('hover');
                                                if($hover.size() === 0){
                                                    $first.addClass('hover');
                                                }
                                            }
                                            break;
                                        case 13:// enter
                                            $m.find('LI.hover A').trigger('click');
                                            break;
                                        case 27: // esc
                                            docElem.trigger('click');
                                            break;
                                    }
                                });
                                // When items are selected
                                $m.find('A').unbind('click');
                                $m.find('LI:not(.disabled) A').click(function(){
                                    var menu = $('.contextMenu');
                                    var checked = $(this).attr('checked');
                                    switch($(this).attr('type')){// custom attribute
                                        case 'radio':
                                            $(this).parent().parent().find('.checked').removeClass('checked').end().find('a[checked="checked"]').removeAttr('checked');
                                            break;
                                        case 'checkbox':
                                            if($(this).attr('checked') || checked){
                                                $(this).removeAttr('checked');
                                                $(this).parent().removeClass('checked');
                                            }else{
                                                $(this).attr('checked', 'checked');
                                                $(this).parent().addClass('checked');
                                            }
                                            menu.hide();
                                            break;
                                        default:
                                            docElem.unbind('click').unbind('keypress');
                                            menu.hide();
                                            break;
                                    }
                                    if(o.onSelect){// Callback
                                        o.onSelect($(this), $(target), $(this).attr('href'), {
                                            x: x - offset.left,
                                            y: y - offset.top,
                                            docX: x,
                                            docY: y
                                        });
                                    }
                                    return false;
                                }); // Hide bindings
                                // eslint-disable-next-line angular/timeout-service
                                setTimeout(function(){ // Delay for Mozilla
                                    docElem.on('click', function(){
                                        docElem.unbind('click').unbind('keypress');
                                        $m.fadeOut(o.fadeOut);
                                        return false;
                                    });
                                }, 0);
                                window.hideContextMenu = function(){
                                    $m.fadeOut(o.fadeOut);
                                };
                            }
                        });
                    });
                    // Disable text selection //TODO reformat with less if/elseif
                    /** @namespace $.browser.mozilla */
                    if($.browser && $.browser.mozilla){
                        $m.each(function(){
                            $(this).css({ 'MozUserSelect': 'none' });
                        });
                    }else{

                        /** @namespace $.browser.msie */
                        if($.browser && $.browser.msie){
                            $m.each(function(){
                                $(this).bind('selectstart.disableTextSelect', function(){
                                    return false;
                                });
                            });
                        }else{
                            $m.each(function(){
                                $(this).bind('mousedown.disableTextSelect', function(){
                                    return false;
                                });
                            });
                        }
                    }
                    // Disable browser context menu (requires both selectors to work in IE/Safari + FF/Chrome)
                    el.add($('UL.contextMenu')).bind('contextmenu', function(){
                        return false;
                    });
                });
                return $(this);
            },
            destroyContextMenu: function(){ // Destroy context menu(s)
                // Destroy specified context menus
                $(this).each(function(){// Disable action
                    $(this).unbind('mousedown').unbind('mouseup');
                });
                return $(this);
            }
        });
})(jQuery);
var GEMSS = {};

GEMSS.Symbol = function(mapControl, layerNode){
    this.paper = undefined;
    this.mapControl = mapControl;
    if(mapControl){
        this.paper = mapControl.getCanvas();
        if(layerNode){
            this.symbolGroup = layerNode.nestedSvg.g();
        }else{
            this.symbolGroup = this.paper.g();
        }
    }
};
GEMSS.Symbol.prototype.changeState =  function(newState){
    return;
}
GEMSS.Symbol.prototype.computeTextSize = function(parent, rect, text, options){
    //init invisible text to compute sizes
    options = $.extend(true, {}, options);
    options.visibility = 'hidden';
    var fakeTextElement = parent.text(rect.X, rect.Y, text.toString());
    fakeTextElement.attr(options);
    setTimeout(function(){
        fakeTextElement.remove();
    }, 1);
    return fakeTextElement.getBBox();
};
GEMSS.Symbol.prototype.computeValueTextPosition = function(parent, value, textOptions, alignment, nested){
    alignment = alignment || 'Center';
    if(['Center', 'Left', 'Right'].indexOf(alignment) < 0){
        alignment = 'Center';
    }
    textOptions = textOptions || {};
    var valueSizes = this.computeTextSize(parent, this.originalRectangle, value, textOptions);
    var valueX = Math.floor(this.originalRectangle.X + (this.originalRectangle.Width / 2) - (valueSizes.width / 2));
    var valueY = this.originalRectangle.Y + this.originalRectangle.Height - Math.floor(valueSizes.height / 2);
    switch(alignment){
        case 'Left':
            valueX = this.originalRectangle.X;
            valueY = this.originalRectangle.Y;
            break;
        case  'Right':
            valueX = this.originalRectangle.X + this.originalRectangle.Width - valueSizes.width - 1;
            break;
        default:
            valueX = valueX < this.originalRectangle.X ? this.originalRectangle.X : valueX;
            break;
    }
    if(nested){
        valueX = valueX - this.originalRectangle.X;
    }
    return { x: valueX, y: valueY };

};
GEMSS.Symbol.prototype.buildTextOptions = function(textFormat, color){
    var textOptions = {};
    textFormat = textFormat || '';
    var textInfo = textFormat.split(',') || '';
    var textDecoration = '';
    var font = textInfo.shift() || ''.strip();
    textOptions[ 'font-family' ] = gemssMapGlobals.FONT_TO_FONT_FAMILY[ font ] || gemssMapGlobals.DEFAULT_FONT_FAMILY;
    textOptions[ 'font-size' ] = textInfo.shift() || gemssMapGlobals.DEFAULT_FONT_SIZE;
    var style = textInfo.shift() || '';
    textInfo = textInfo.shift() || '';
    if(textInfo.includes('Underline')){
        textDecoration += 'underline ';
    }
    if(textInfo.includes('Strikeout')){
        textDecoration += 'line-through ';
    }
    if(textDecoration.length){
        textOptions[ 'text-decoration' ] = textDecoration;
    }
    if(style.indexOf('Bold') > -1){
        textOptions[ 'font-weight' ] = 'bold';
    }
    if(style.indexOf('Italic') > -1){
        textOptions[ 'font-style' ] = 'italic';
    }
    if(color){
        textOptions[ 'color' ] = color;
        textOptions[ 'fill' ] = color;
    }
    return textOptions;
};
GEMSS.Symbol.prototype.getImage = function(){
    //TODO - return default img
    return this.imageBasePathURI + this.okFileId;
};

GEMSS.Symbol.prototype.getImage = function(){
    /** @namespace this.okFileId */
    var iconData = this.okFileId;
    // return this.imageBasePathURI + this._InOrderFileId;
    if(this.status !== undefined && this.status !== null){
        var iconState = this.status.split('|')[ 0 ];
        var blinkState = this.status.split('|')[ 1 ];

        switch(iconState){
            case 'NOTIFICATION':
                /** @namespace this.notificationFileId */
                iconData = this.notificationFileId;
                break;
            case 'WARNING':
                /** @namespace this.warningFileId */
                iconData = this.warningFileId;
                break;
            case 'PREALLARM':
                /** @namespace this.preallarmFileId */
                iconData = this.preallarmFileId;
                break;
            case 'ALLARM':
                /** @namespace this.allarmFileId */
                iconData = this.allarmFileId;
                break;
            case 'PRIORITY':
                /** @namespace this.priorityFileId */
                iconData = this.priorityFileId;
                break;
            case 'EMERGENCY':
                /** @namespace this.emergencyFileId */
                iconData = this.emergencyFileId;
                break;
        }
        this.blink = blinkState === 'PERSISTENCE';
    }
    if(iconData){
        iconData = this.imageBasePathURI + iconData;
    }
    return iconData;
};
GEMSS.Symbol.prototype.isPopup = function(){
    /** @namespace this.popUpStyle */
    /** @namespace this.popUpStyle */
    return this.popUpStyle !== undefined && this.popUpStyle === true;
};
GEMSS.Symbol.prototype.setVisibility = function(visible){
    if(visible === true){
        this.symbolGroup.attr('display', '');
        this.symbolGroup.hide = visible;
    }else{
        if(visible === false){
            this.symbolGroup.attr('display', 'none');
            this.symbolGroup.hide = visible;
        }
    }
};
/**
 * This function defines behaviour of click event on single node - Event should be of navigation type if symbol is not connected to popup map
 *
 */
GEMSS.Symbol.prototype.onClickEvent = function(){
    if(this.isPopup()){
        /** @namespace this.popUpHeight */
        /** @namespace this.popUpWidth */
        this.mapControl.openPopupMap(this.guidLink, parseInt(this.width, 10), parseInt(this.height, 10), this);
    }else{
        this.mapControl.navigateMap(this);
    }
};
GEMSS.Symbol.prototype.setClickEvent = function(){
    var that = this;
    if(this.guidLink !== undefined && this.guidLink != null){
        this.symbolGroup.attr('cursor', 'pointer');
        this.symbolGroup.click(function(){
            that.onClickEvent();
        });
    }else{
        /** @namespace this.coordinate */
        if(this.coordinate !== undefined){
            // command click
            /** @namespace this.defaultCommand */
            this.symbolGroup.click(function(){
            });
            this.setContextMenu();
        }
    }
};
GEMSS.Symbol.prototype.setHoverEvent = function(){
    if((this.label || this.description) !== undefined){
        var title = Snap.parse('<title>' + (this.label || this.description) + '</title>');
        this.symbolGroup.append(title);
    }
};

GEMSS.Symbol.prototype.setCommandPopupHandler = function(){
    var that = this;
    if(!that.$type.includes('WebBrowserSymbol')){
        $([this.symbolGroup.node]).click(function(){
            that.mapControl.getCommand(that.command, function(commands){
                var popup = that.mapControl.openCommandPopup(that, commands);
                popup.result.then(function(chosenCommand){
                    if(chosenCommand.r_protocol === 'GEMSS_NOTE_LIST' || chosenCommand.r_protocol === 'GEMSS_PROPERTY_LIST' || chosenCommand.r_protocol === 'CHART'){
                        if(chosenCommand.r_protocol === 'GEMSS_PROPERTY_LIST'){
                            that.mapControl.sendPropertyListCommand(that.gemssodeInstance, that.command);
                        }else{
                            if(chosenCommand.r_protocol === 'CHART'){
                                that.mapControl.openChartModal(that.gemssNodeInstance);
                            }else{
                                that.mapControl.sendNoteListCommand(that.gemssNodeInstance, that.command);
                            }
                        }
                    }else{
                        that.mapControl.sendCommand(that.gemssNodeInstance, chosenCommand);
                    }
                }, function(){
                });
            });
        });
    }
};
/**
 * Set Left-click Context Menu With commands async auto-loading
 */


GEMSS.Symbol.prototype.setSymbolClickEvent = function() {
    var that = this;
    try {
        $([this.symbolGroup.node]).contextMenu({
            onClick: function() {
                that.mapControl.getCommand(that.command, function(commands) {
                    if(!commands || commands.length === 0) {
                        return;
                    }
                    var command = commands[0];
                    var protocol = command.r_protocol;
                    if(protocol.toLowerCase().includes('?')) {
                        that.mapControl.askForValue({
                            title: 'Inserire valore per comando ' + command.r_description,
                            label: 'valore'
                        }).result.then(function(data){
                            command = angular.copy(command, {}, true);
                            command.r_protocol = command.r_protocol.replace('?', data.value.toString());
                            that.mapControl.sendCommand(that.gemssNodeInstance, command);
                        });
                    } else{
                        if(protocol.includes('time-slot')){
                            protocol='time-slot';
                        }
                        if(protocol.includes('CHART')){
                            protocol=protocol.split('|');
                            protocol=protocol[protocol.length-1];
                        }
                        switch(protocol){
                            case 'CHART_TOTAL':
                                that.mapControl.openTotalsModal(that.gemssNodeInstance,command);
                                break;
                            case 'CHART':
                                that.mapControl.openChartModal(that.gemssNodeInstance,command);
                                break;
                            case'GEMSS_NOTE_LIST':
                                that.mapControl.sendNoteListCommand(that.gemssNodeInstance, that.command);
                                break;
                            case'GEMSS_PROPERTY_LIST':
                                that.mapControl.sendPropertyListCommand(that.gemssNodeInstance, that.command);
                                break;
                            case'time-slot':
                                that.mapControl.openTimeSlotModal(that.gemssNodeInstance,that.command,that.mapControl.sendCommand);
                                break;
                            default:
                                that.mapControl.sendCommand(that.gemssNodeInstance, command);
                        }
                    }
                });
            },
            allowPreventDefaultWhenAppleMobile: that.mapControl.getOptionForAppleMobile && that.mapControl.getOptionForAppleMobile('ALLOW_PREVENT_DEFAULT_FOR_APPLE_MOBILE'),
            allowStopPropagationWhenAppleMobile: that.mapControl.getOptionForAppleMobile && that.mapControl.getOptionForAppleMobile('ALLOW_STOP_PROPAGATION_FOR_APPLE_MOBILE')
         });
    }
    catch(error) {
        console.log('[setSymbolClickEvent] error:', error);
    }
};

GEMSS.Symbol.prototype.setContextMenu = function(){
    var that = this;
    /** @namespace this.menuVisible */
    if(this.menuVisible){
        this.symbolGroup.attr('cursor', 'pointer');
        this.symbolGroup.click(function(){
        });

        if(checkMobile()){
            // console.log('checkTouch');
            if(that.defaultCommand){
                $([that.symbolGroup.node]).click(function(){
                    that.mapControl.sendDefaultCommand(that);
                });
            } else if(that.delayClick) {
                that.delayClick();
            }
            else{
                that.setCommandPopupHandler();
            }
        }else{
            // console.log('onclickVST');
            if(this.defaultCommand){
                $([that.symbolGroup.node]).click(function(){
                    that.mapControl.sendDefaultCommand(that);
                });
            }
            //added to managed devices standard and touch
            if(!checkMobile() && checkTouchDevice()){
                // console.log('aggiunto comando per Touch');
                if(that.delayClick) {
                    that.delayClick();
                }
                else{
                    that.setCommandPopupHandler();
                }
            }
            $([that.symbolGroup.node]).contextMenu({
                menu: 'menuRect',
                menuOffset:that.menuOffset,
                onShow: function(){// TODO refactor
                    var $menu = $('#menuRect');
                    that.select();
                    $menu.empty();
                    var htmlEl = '<li class=""><a href="#">Caricamento Comandi</a></li>';
                    $menu.append(htmlEl);
                    try{
                        that.mapControl.getCommand(that.command, function(commands){
                            if(!that.graph){
                                commands = commands.filter(function(command){
                                    return !command.r_protocol.includes('CHART');
                                });
                            }
                            commands.push({
                                r_description: 'Proprietà',
                                r_protocol: 'GEMSS_PROPERTY_LIST'
                            });

                            if(!(that instanceof ModBusSymbol)){
                                commands.push({
                                    r_description: 'Note Operative',
                                    r_protocol: 'GEMSS_NOTE_LIST'
                                });
                            }
                            $menu.empty();
                            for(var i in commands){
                                htmlEl = '<li class=""><a  data-command-index="' + i + '" href="#size_100">' + commands[ i ].r_description + '</a></li>';
                                $menu.append(htmlEl);
                            }
                            $menu.find('A')
                                .mouseover(function(){
                                    $menu.find('LI.hover').removeClass('hover');
                                    $(this).parent().addClass('hover');
                                })
                                .mouseout(function(){
                                    $menu.find('LI.hover').removeClass('hover');
                                });
                            $menu.find('A').unbind('click');
                            $menu.find('LI:not(.disabled) A').click(function(event){
                                event.preventDefault();
                                event.stopPropagation();
                                $(this).parent().parent().find('.checked').removeClass('checked').end().find('a[checked="checked"]').removeAttr('checked');
                                $('.contextMenu').hide();
                                var index = $(this).attr('data-command-index');
                                var protocol = commands[ index ].r_protocol;
                                if(protocol.toLowerCase().includes('?')){
                                    that.mapControl.askForValue({
                                        title: 'Inserire valore per comando ' + commands[ index ].r_description,
                                        label: 'valore'
                                    }).result.then(function(data){
                                        commands[ index ] = angular.copy(commands[ index ], {}, true);
                                        commands[ index ].r_protocol = commands[ index ].r_protocol.replace('?', data.value.toString());
                                        that.mapControl.sendCommand(that.gemssNodeInstance, commands[ index ]);
                                    });
                                }else{
                                    if(protocol.includes('time-slot')){
                                        protocol='time-slot';
                                    }
                                    if(protocol.includes('CHART')){
                                        protocol=protocol.split('|');
                                        protocol=protocol[protocol.length-1];
                                    }
                                    switch(protocol){
                                        case 'CHART_TOTAL':
                                            that.mapControl.openTotalsModal(that.gemssNodeInstance,commands[ index ]);
                                            break;
                                        case 'CHART':
                                            that.mapControl.openChartModal(that.gemssNodeInstance,commands[ index ]);
                                            break;
                                        case'GEMSS_NOTE_LIST':
                                            that.mapControl.sendNoteListCommand(that.gemssNodeInstance, that.command);
                                            break;
                                        case'GEMSS_PROPERTY_LIST':
                                            that.mapControl.sendPropertyListCommand(that.gemssNodeInstance, that.command);
                                            break;
                                        case'time-slot':
                                            that.mapControl.openTimeSlotModal(that.gemssNodeInstance,that.command,that.mapControl.sendCommand);
                                            break;
                                        default:
                                            that.mapControl.sendCommand(that.gemssNodeInstance, commands[ index ]);
                                    }
                                }
                                that.deSelect();
                            });
                        });
                    }catch(error){
                        htmlEl = '<li class=""><a type="radio" name="size" val="100" href="#size_100">Errore</a></li>';
                        $menu.empty();
                        $menu.append(htmlEl);
                    }
                },
                onSelect: function(){
                },
                fadeOut: function(){
                    that.highLighted = false;
                    that.draw();
                }
            });
        }
    }
};
/**
 * Draw Graphic Symbol on Map
 * @return {[type]} [description]
 */
GEMSS.Symbol.prototype.drawHighLightRect = function(){
    // cover rect for  per highlight
    /** @namespace this.originalRectangle */
    this.highLightRectangleElement = this.wrapperGroup.rect(this.originalRectangle.X, this.originalRectangle.Y, this.originalRectangle.Width, this.originalRectangle.Height);
    this.highLightRectangleElement.attr({ 'stroke': 'blue', 'stroke-width': '0', 'fill': 'none' });
};
GEMSS.Symbol.prototype.drawInit = function(){
    if(!this.wrapperGroup){
        this.wrapperGroup = this.symbolGroup.g();
    }
    // background drawing
    var img = this.getImage();
    if(img){
        this.symbolIconElement = this.wrapperGroup.image(img, this.originalRectangle.X, this.originalRectangle.Y, this.originalRectangle.Width, this.originalRectangle.Height);
    }
    this.drawHighLightRect();
    this.drawHighLighted();
    this.drawLabel(this.originalRectangle);
    this.setClickEvent();
    this.setHoverEvent();
};
GEMSS.Symbol.prototype.drawUpdate = function(){
    //symbol already exists...
    if(this.symbolIconElement && this.getImage()){
        this.symbolIconElement.attr({ 'href': this.getImage() });
    }
    //todo move after switch on update/init?
    this.drawHighLighted();
};
GEMSS.Symbol.prototype.drawBlink = function(){
    if(this.symbolIconElement){
        if(this.blink === true){
            this.symbolIconElement.addClass('svg-blink');
        }else{
            // FIXME keep the opacity of the previous blink to the item
            this.symbolIconElement.removeClass('svg-blink');
            this.symbolIconElement.attr({ opacity: 1 });
        }
    }
};
GEMSS.Symbol.prototype.drawText = function(parent, x, y, value, textOptions, xGutter, yGutter){
    //parent=parent;//||this.wrapperGroup;
    value = value || '';
    textOptions = textOptions || {};
    xGutter = xGutter || 0;
    yGutter = yGutter || 0;
    var txt = parent.text(x + xGutter, y + yGutter, value);
    txt.attr(textOptions);
    return txt;
};
GEMSS.Symbol.prototype.applyRotation = function(target){
    target = target || this.wrapperGroup;
    if(this.rotationAngle){
        var bBox = target.getBBox(); //bounding box, get coords and centre
        /** @namespace this.rotationAngle */
        target.animate({ transform: 'r' + this.rotationAngle + ',' + bBox.cx + ',' + bBox.cy }, 0);
    }
};
GEMSS.Symbol.prototype.draw = function(){
    //init or update symbol item
    this.symbolIconElement || this.drawn ? this.drawUpdate() : this.drawInit();
    this.drawBlink();
    /*Rotation*/
    this.applyRotation();

};
GEMSS.Symbol.prototype.select = function(){
    this.mapControl.onSelectSymbol(this);
    this.highLighted = true;
    this.draw();
};
GEMSS.Symbol.prototype.deSelect = function(){
    this.mapControl.deSelectSymbol(this);
    this.highLighted = false;
    this.draw();
};
GEMSS.Symbol.prototype.notifySelectionOnMap = function(){
    this.deSelect();
};
/**
 * Draw
 * @return {[type]} [description]
 */
GEMSS.Symbol.prototype.drawHighLighted = function(){
    /**@namespace this.highLightRectangleElement.attr */
    if(this.highLighted){
        this.highLightRectangleElement.attr({ 'stroke': 'blue', 'stroke-width': '3', 'fill': 'none' });
    }else{
        this.highLightRectangleElement.attr({ 'stroke': 'blue', 'stroke-width': '0', 'fill': 'none' });
    }
};
/**
 * Draw Element Label - Description.
 *
 */
GEMSS.Symbol.prototype.drawLabel = function(originalRectangle){
    if(this.label !== undefined){
        var that = this;
        /** @namespace this.labelFontColor */
        /** @namespace this.labelFont */
        var styleAttr = this.buildTextOptions(this.labelFont, this.labelForeColor); // fixme with is the correct one?
        styleAttr[ 'text-anchor' ] = 'middle';
        var yGutter = 0;
        var posY = parseInt(originalRectangle.Y, 10) + parseInt(originalRectangle.Height, 10) + 10;
        //TODO - add other position cases
        switch(this.labelPosition){
            case 'Inside':
                var fontSize = Number(styleAttr[ 'font-size' ].replace('pt', ''));
                var yOffset = fontSize * 0.45;
                posY = (parseInt(originalRectangle.Y, 10) + parseInt(originalRectangle.Height, 10) / 2) + yOffset;
                that.labelAlwaysVisible = true;
                break;
            case 'Below':
                posY = parseInt(originalRectangle.Y, 10) + parseInt(originalRectangle.Height, 10) + 10;
                yGutter = Number(styleAttr[ 'font-size' ].replace('pt', ''));
                break;
            default:
                posY = parseInt(originalRectangle.Y, 10) + parseInt(originalRectangle.Height, 10) + 10;
                yGutter = Number(styleAttr[ 'font-size' ].replace('pt', ''));
                break;
        }
        var posX = parseInt(originalRectangle.X, 10) + (parseInt(originalRectangle.Width, 10) / 2);
        this.labelElement = this.drawText(this.wrapperGroup, posX, posY, this.label, styleAttr, 0, yGutter);
        // on init - hide labels
        if(!this.isLabelAlwaysVisible()){
            this.labelElement.attr('display', 'none');
        }
        this.labelElement.hide = true;
    }
};
GEMSS.Symbol.prototype.isLabelAlwaysVisible = function(){
    return this.labelAlwaysVisible;
};
/**
 * Toggles Symbol Label (show/hide)
 */
GEMSS.Symbol.prototype.toggleLabel = function(){
    if(this.isLabelAlwaysVisible()){
        this.labelElement.attr('display', '');
        return;
    }
    if(this.labelElement && this.labelElement.hide !== true){
        this.labelElement.attr('display', 'none');
        this.labelElement.hide = true;
    }else{
        if(this.labelElement !== undefined){
            this.labelElement.attr('display', '');
            this.labelElement.hide = false;
        }
    }
};
GEMSS.Symbol.prototype.hydrate = function(o){
    for(var i in o){
        this[ i ] = o[ i ];
    }
};

function IconSymbol(){
}

IconSymbol.prototype = new GEMSS.Symbol();
// noinspection JSUnusedGlobalSymbols
IconSymbol.prototype.constructor = IconSymbol;

/**
 * LabelSymbol
 * @type {LabelSymbol}
 */
function LabelSymbol(){
    GEMSS.Symbol.apply(this, arguments);
    this.textXGutter = 4;
    this.textYGutter = 4;
}

LabelSymbol.prototype = new IconSymbol();
// noinspection JSUnusedGlobalSymbols
LabelSymbol.prototype.constructor = LabelSymbol;
// noinspection JSUnusedGlobalSymbols
LabelSymbol.prototype.uber = IconSymbol.prototype;
LabelSymbol.prototype.toggleLabel = function(){
};//do nothing
// noinspection JSUnusedGlobalSymbols


LabelSymbol.prototype.getImage = function(){
    //TODO - return default img
    return this.imageBasePathURI + this.iconFileId;
};
// noinspection JSUnusedGlobalSymbols
/**
 * [draw description]
 * @return {[type]} [description]
 */
LabelSymbol.prototype.draw = function(){
    if(!this.wrapperGroup){
        this.wrapperGroup = this.symbolGroup.g();
    }
    this.nestedSvg = this.wrapperGroup.svg(this.originalRectangle.X, this.originalRectangle.Y, this.originalRectangle.Width, this.originalRectangle.Height);
    // background drawing
    var img = this.getImage();
    if(img){
        this.symbolIconElement = this.nestedSvg.image(img, 0, 0, this.originalRectangle.Width, this.originalRectangle.Height);
    }
    var rect = this.nestedSvg.rect(0, 0, this.originalRectangle.Width, this.originalRectangle.Height);
    rect.attr({ 'fill-opacity': 0 });
  
    
    /** @namespace this.labelForeColor */
    var options = this.buildTextOptions(this.labelFont, this.labelForeColor);
    options[ 'dy' ] = '.3em';
    var textPosition = this.computeValueTextPosition(this.wrapperGroup, this.label, options, this.alignment, true);
    //this.text = this.drawText(this.nestedSvg, textPosition.x, textPosition.y, this.label, options);
    this.text = this.nestedSvg.text(textPosition.x, '50%', this.label);
    this.text.attr(options);
    this.applyRotation();
};

/**
 * LinkSymbol
 * @type {LinkSymbol}
 */
function LinkSymbol(){
    GEMSS.Symbol.apply(this, arguments);
}

LinkSymbol.prototype = new IconSymbol();
LinkSymbol.prototype.isSymbol = true;
// noinspection JSUnusedGlobalSymbols
LinkSymbol.prototype.constructor = LinkSymbol;
LinkSymbol.prototype.uber = IconSymbol.prototype;
// noinspection JSUnusedGlobalSymbols
/**
 * Get Image based upon current state
 * @return {[type]} [description]
 */

LinkSymbol.prototype.getImage = function(){
    var iconData = this.okFileId;
    // return this.imageBasePathURI + this._InOrderFileId;
    if(this.status !== undefined){
        var iconState = this.status.split('|')[ 0 ];
        var blinkState = this.status.split('|')[ 1 ];
        switch(iconState){
            case 'NOTIFICATION':
                iconData = this.notificationFileId;
                break;
            case 'WARNING':
                iconData = this.warningFileId;
                break;
            case 'PREALLARM':
                iconData = this.preallarmFileId;
                break;
            case 'ALLARM':
                iconData = this.allarmFileId;
                break;
            case 'PRIORITY':
                iconData = this.priorityFileId;
                break;
            case 'EMERGENCY':
                iconData = this.emergencyFileId;
                break;
        }
        this.blink = blinkState === 'PERSISTENCE';
    }
    if(iconData){
        iconData = this.imageBasePathURI + iconData;
    }
    return iconData;
};
// noinspection JSUnusedGlobalSymbols
LinkSymbol.prototype.draw = function(){
    this.uber.draw.call(this, this.LinkSymbolElement);
    if(!this.wrapperGroup){
        this.wrapperGroup = this.symbolGroup.g();
    }
    if(!this.labelElement){
        var posY = parseInt(this.originalRectangle.Y, 10) + parseInt(this.originalRectangle.Height, 10) / 2;
        var posX = parseInt(this.originalRectangle.X, 10) + (parseInt(this.originalRectangle.Width, 10) / 2);
        this.LinkSymbolElement = this.wrapperGroup.text(posX, posY, this.label).attr({ 'text-anchor': 'middle' });
    }
};
LinkSymbol.prototype.onClickEvent = function(){
    this.mapControl.navigateToGuid(this);
};
// noinspection JSUnusedGlobalSymbols
LinkSymbol.prototype.setClickEvent = function(){
    var that = this;
    this.symbolGroup.attr('cursor', 'pointer');
    this.symbolGroup.click(function(){
        that.onClickEvent();
    });
};

/**
 * [MultiSelectionVisibleSymbol description]
 * @type {MultiSelectionVisibleSymbol}
 */
function MultiSelectionVisibleSymbol(){
    GEMSS.Symbol.apply(this, arguments);
}

MultiSelectionVisibleSymbol.prototype = new IconSymbol();
// noinspection JSUnusedGlobalSymbols
MultiSelectionVisibleSymbol.prototype.constructor = MultiSelectionVisibleSymbol;
MultiSelectionVisibleSymbol.prototype.uber = IconSymbol.prototype;
// noinspection JSUnusedGlobalSymbols
MultiSelectionVisibleSymbol.prototype.getImage = function(){
    /** @namespace this.iconFileId */
    return this.imageBasePathURI + this.iconFileId;
};
// noinspection JSUnusedGlobalSymbols
MultiSelectionVisibleSymbol.prototype.draw = function(){
    /** @namespace this.MultiSelectionVisibleSymbolElement */
    this.uber.draw.call(this, this.MultiSelectionVisibleSymbolElement);
};

MultiSelectionVisibleSymbol.prototype.onClickEvent = function(){
    /** @namespace this.symbolsVisible.$values */
    /** @namespace this.symbolsNotVisible */
    /** @namespace this.symbolsVisible */
    this.mapControl.setNodesVisibility(this.symbolsVisible.$values, this.symbolsNotVisible.$values);
};
// noinspection JSUnusedGlobalSymbols
MultiSelectionVisibleSymbol.prototype.setClickEvent = function(){
    var that = this;
    this.symbolGroup.attr('cursor', 'pointer');
    this.symbolGroup.click(function(){
        that.onClickEvent();
    });
};

/**
 * Layer Symbol Construct
 * @type {LayerSymbol}
 */
function LayerSymbol(){
    GEMSS.Symbol.apply(this, arguments);
}

LayerSymbol.prototype = new IconSymbol();
// noinspection JSUnusedGlobalSymbols
LayerSymbol.prototype.constructor = LayerSymbol;
LayerSymbol.prototype.uber = IconSymbol.prototype;
// noinspection JSUnusedGlobalSymbols
LayerSymbol.prototype.getImage = function(){
    return null;
};
// noinspection JSUnusedGlobalSymbols
LayerSymbol.prototype.draw = function(){
    var that = this;
    this.nestedSvg = this.paper.svg(this.originalRectangle.X, this.originalRectangle.Y, this.originalRectangle.Width, this.originalRectangle.Height);
    this.nestedSvg.attr({ 'preserveAspectRatio': 'none' });
    this.backGroundGroup = this.nestedSvg.g();
    //FIXME new system must be passed by web service
    this.nestedSvg.attr({ 'viewBox': '0 0 1600 1000' });
    this.mapControl.getNodeData(this.guidLink, this).then(function(data){
        /** @namespace data.r_symbolconfiguration.backGroundFileId */
        that.nestedBackGroundImage = that.backGroundGroup.image(that.imageBasePathURI + data.r_symbolconfiguration.backGroundFileId);
    });
    this.uber.draw.call(this, this.LayerSymbolElement);
    if(!this.wrapperGroup){
        this.wrapperGroup = this.symbolGroup.g();
    }
    var posY = parseInt(this.originalRectangle.Y, 10) + parseInt(this.originalRectangle.Height, 10) / 2;
    var posX = parseInt(this.originalRectangle.X, 10) + (parseInt(this.originalRectangle.Width, 10) / 2);
    this.LayerSymbolElement = this.wrapperGroup.text(posX, posY, this.label).attr({ 'text-anchor': 'middle' });
};
// noinspection JSUnusedGlobalSymbols
LayerSymbol.prototype.setClickEvent = function(){
};

/**
 * [AntintrusionSymbol description]
 * @type {AntintrusionSymbol}
 */
function AntintrusionSymbol(){
    GEMSS.Symbol.apply(this, arguments);
}

AntintrusionSymbol.prototype = new IconSymbol();
// noinspection JSUnusedGlobalSymbols
AntintrusionSymbol.prototype.constructor = AntintrusionSymbol;
// noinspection JSUnusedGlobalSymbols
AntintrusionSymbol.prototype.uber = IconSymbol.prototype;
// noinspection JSUnusedGlobalSymbols
AntintrusionSymbol.prototype.getImage = function(){
    /** @namespace this._InOrderFileId */
    var iconData = this.imageBasePathURI + this._InOrderFileId;
    // return this.imageBasePathURI + this._InOrderFileId;
    if(this.status === undefined){
        return this.imageBasePathURI + this._InOrderFileId;
    }
    var iconState = this.status.split('|')[ 0 ];
    var blinkState = this.status.split('|')[ 1 ];

    switch(iconState){
        case 'ALLARME':
            /** @namespace this._EmergencyFileId */
            if(blinkState === 'WARNING'){ //TODO improve maybe hadle in same way as dashboard?
                /** @namespace this._WarningFileId */
                iconData = this.imageBasePathURI + this._WarningFileId;
            }else{
                iconData = this.imageBasePathURI + this._EmergencyFileId;
            }
            break;
        case 'MANOMISSIONE':
            /** @namespace this._ManomissionFileId */
            iconData = this.imageBasePathURI + this._ManomissionFileId;
            break;
        case 'GUASTO':
            /** @namespace this._FailureFileId */
            iconData = this.imageBasePathURI + this._FailureFileId;
            break;
        case 'WARNING': // FIXME is not used because handle as blinkstate in allarm state
            /** @namespace this._WarningFileId */
            iconData = this.imageBasePathURI + this._WarningFileId;
            break;
        case 'FUORISERVIZIO':
            if(blinkState === 'SI'){
                /** @namespace this._OutOfOrderFileId */
                iconData = this.imageBasePathURI + this._OutOfOrderFileId;
            }
            break;
    }

    this.blink = ['INCORSO', 'INCORSONONMEMORIZZATO'].includes(blinkState);

    return iconData;
};
// noinspection JSUnusedGlobalSymbols
AntintrusionSymbol.prototype.draw = function(){
    this.uber.draw.call(this);
};
AntintrusionSymbol.prototype.setClickEvent = function() {
   if(this instanceof ModBusSymbol) this.setSymbolClickEvent();
   this.setContextMenu();
};
function ModBusSymbol(){
    GEMSS.Symbol.apply(this, arguments);
    this.internalBorderGutter = 2;
    this.alertBorderStroke = 8;
}

ModBusSymbol.prototype = new AntintrusionSymbol();
// noinspection JSUnusedGlobalSymbols
ModBusSymbol.prototype.constructor = ModBusSymbol;
ModBusSymbol.prototype.uber = IconSymbol.prototype;
// noinspection JSUnusedGlobalSymbols
ModBusSymbol.prototype.draw = function(){
    this.uber.draw.call(this);
};
ModBusSymbol.prototype.draw = function(){
    //init or update symbol item

    this.blink = false;
    // management of status which includes - delimiter
    if (this.status.includes('-')){
        //blink only if ALLARM after -
        var blinkState = this.status.split('-')[ 1 ];
        this.blink = blinkState === 'ALLARM'; //blinkState === 'PERSISTENCE';
        this.onOffStatus = this.status.split('-')[ 0 ] === 'true' || this.status.split('-')[ 0 ] === '1';
        this.originalStatus = this.status;
        //FIXME - i d rather change status inside a common interface before redraw (websocket update don t renew symbol)
        //change status without delimiter
        this.status = this.status.split('-')[ 0 ];
    } else {
        this.onOffStatus = this.status === 'true' || this.status === '1';
    }

    this.symbolIconElement || this.drawn ? this.drawUpdate() : this.drawInit();
    this.drawBlink();
    /*Rotation*/
    this.applyRotation();
};
// noinspection JSUnusedGlobalSymbols
ModBusSymbol.prototype.getImage = function(){
    /** @namespace this.imageShapeId */
    return this.imageShapeId ? this.imageBasePathURI + this.imageShapeId : null;
};

ModBusSymbol.prototype.drawBorder = function(){
    var stroke;
    var width;
    switch(this.borderStyle){
        case 'None':
            break;
        case 'FixedSingle':
            stroke = '#d3d3d3';
            width = 1;
            break;
        default:
            stroke = 'grey';
            width = 1;
            break;
    }
    if(stroke){
        this.borderRect = this.wrapperGroup.rect(this.originalRectangle.X + this.internalBorderGutter,
            this.originalRectangle.Y + this.internalBorderGutter,
            this.originalRectangle.Width - this.internalBorderGutter,
            this.originalRectangle.Height - this.internalBorderGutter);
        this.borderRect.attr({ 'stroke': stroke, 'stroke-width': width, 'fill': !!this.backColor?this.backColor:'none' });
    }
};

ModBusSymbol.prototype.delayClick = function() {
    $([this.symbolGroup.node]).off('touchend');
    $([this.symbolGroup.node]).off('touchstart');

    var that = this;
    var timeoutId = null;
    $([that.symbolGroup.node]).on('touchstart', function() { 
        timeoutId = setTimeout(function() {
            that.mapControl.getCommand(that.command, function(commands) {
                var popup = that.mapControl.openCommandPopup(that, commands);
                popup.result.then(function(chosenCommand){
                    if(chosenCommand.r_protocol === 'GEMSS_NOTE_LIST' || chosenCommand.r_protocol === 'GEMSS_PROPERTY_LIST' || chosenCommand.r_protocol === 'CHART'){
                        if(chosenCommand.r_protocol === 'GEMSS_PROPERTY_LIST'){
                            that.mapControl.sendPropertyListCommand(that.gemssodeInstance, that.command);
                        }else{
                            if(chosenCommand.r_protocol === 'CHART'){
                                that.mapControl.openChartModal(that.gemssNodeInstance);
                            }else{
                                that.mapControl.sendNoteListCommand(that.gemssNodeInstance, that.command);
                            }
                        }
                    }else{
                        that.mapControl.sendCommand(that.gemssNodeInstance, chosenCommand);
                    }
                }, function() { });
            });
        }, 1000);
    });
    $([that.symbolGroup.node]).on('touchend', function() {
        if(timeoutId !== null) clearInterval(timeoutId);
    });
}

function MODBUSSymbolValueStatic(){
    GEMSS.Symbol.apply(this, arguments);
    this.textXGutter = -2;
    //this.textYGutter=5;
    this.showValue = true;
}

MODBUSSymbolValueStatic.prototype = new ModBusSymbol();
// noinspection JSUnusedGlobalSymbols
MODBUSSymbolValueStatic.prototype.constructor = MODBUSSymbolValue;
// noinspection JSUnusedGlobalSymbols
MODBUSSymbolValueStatic.prototype.drawInit = function(){
    this.drawn = true;
    if(!this.wrapperGroup){
        this.wrapperGroup = this.symbolGroup.g();
    }
    var img = this.getImage();
    var textPosition;
    var value = this.status === undefined ? '' : this.status;
    var valueBBox;
    value = value === null ? '' : value;
    value = Number(value).toPrecision();
    value = value + ' ' + this.unit;
    this.drawBorder();
    /** @namespace this.foreColor */
    var textOptions = this.buildTextOptions(this.font, this.foreColor);
    if(this.showValue){
        textPosition = this.computeValueTextPosition(this.wrapperGroup, value, textOptions);
        this.textValue = this.drawText(this.wrapperGroup, textPosition.x, textPosition.y, value, textOptions, this.textXGutter, this.textYGutter);
        valueBBox = this.textValue.getBBox();
    }else{
        valueBBox = { height: 0 };
    }
    if(img){
        this.drawImg(img, valueBBox);
    }

    /** DRAW ALERT RECT */
    this.alertRectangleElement = this.wrapperGroup.rect(this.originalRectangle.X + this.alertBorderStroke/2, this.originalRectangle.Y + this.alertBorderStroke/2, this.originalRectangle.Width - this.alertBorderStroke, this.originalRectangle.Height - valueBBox.height - this.alertBorderStroke);
    this.alertRectangleElement.attr({ 'stroke': 'red', 'stroke-width': '0', 'fill': 'none' });
    this.alertRectangleElement.addClass('svg-blink');

    this.drawHighLightRect();
   // this.drawBorder();
    this.drawHighLighted();
    this.drawLabel(this.originalRectangle);
    this.setClickEvent();
    this.setHoverEvent();
};

MODBUSSymbolValueStatic.prototype.drawBlink = function(){
    if(this.alertRectangleElement){
        if(this.blink === true){
            this.alertRectangleElement.addClass('svg-blink');
            this.alertRectangleElement.attr({ 'stroke-width': this.alertBorderStroke });
        }else{
            // FIXME keep the opacity of the previous blink to the item
            this.alertRectangleElement.removeClass('svg-blink');
            this.alertRectangleElement.attr({ 'stroke-width': 0 });
        }
    }
};
MODBUSSymbolValueStatic.prototype.drawImg = function(img, valueBBox){
    this.symbolIconElement = this.wrapperGroup.image(img, this.originalRectangle.X, this.originalRectangle.Y, this.originalRectangle.Width, this.originalRectangle.Height - valueBBox.height);
};
MODBUSSymbolValueStatic.prototype.drawUpdate = function(){
    var img = this.getImage();
    var value = this.status === undefined ? '' : this.status;
    value = value === null ? '' : value;
    value = Number(value).toPrecision();
    value = value + ' ' + this.unit;
    var textOptions = this.buildTextOptions(this.font, this.foreColor);
    if(this.showValue && this.textValue){
        var textPosition = this.computeValueTextPosition(this.wrapperGroup, value, textOptions);
        var prevText = this.textValue;
        this.textValue = this.drawText(this.wrapperGroup, textPosition.x, textPosition.y, value, textOptions, this.textXGutter, 4);
        setTimeout(function(){
            prevText.remove();
        });
    }
    if(img && this.symbolIconElement){
        this.symbolIconElement.attr({ 'href': this.getImage() });
    }
    //todo move after switch on update/init?
    this.drawHighLighted();
};
MODBUSSymbolValueStatic.prototype.getImage = function(){
    /** @namespace this.staticImageId */
    return this.staticImageId ? this.imageBasePathURI + this.staticImageId : null;
};

function MODBUSSymbolValue(){
    GEMSS.Symbol.apply(this, arguments);
    this.textYGutter = 3;
}

MODBUSSymbolValue.prototype = new MODBUSSymbolValueStatic();
// noinspection JSUnusedGlobalSymbols
MODBUSSymbolValue.prototype.constructor = MODBUSSymbolValue;
MODBUSSymbolValue.prototype.preDrawUpdate = MODBUSSymbolValueStatic.prototype.drawUpdate; //is needed before calling uber trow max stack error if uber is other modbus symbol
// noinspection JSUnusedGlobalSymbols
MODBUSSymbolValue.prototype.drawUpdate = function(){
    this.preDrawUpdate();
    if(this.imgBg){
        var bgSize = $.extend(true, {}, this.originalRectangle);
        var valueBBox = this.textValue ? this.textValue.getBBox() : { height: 0 };
        bgSize.Height = bgSize.Height - valueBBox.height;
        bgSize.Height = bgSize.Height - this.drawOption.marginTop - this.drawOption.marginBottom;
        bgSize.Y = bgSize.Y + this.drawOption.marginTop;
        var value = Number(this.status);
        if(this.status > this.max){
            value = this.max;
        }
        var percentToColor = (Math.abs(this.min) + value) / (Math.abs(this.min) + this.max);
        percentToColor = percentToColor <= 1 ? percentToColor : 1;
        var offset = Math.floor(bgSize.Height * (1 - percentToColor));
        bgSize.Height -= offset;
        bgSize.Y += offset;
        var symbolBBox = this.symbolIconElement.getBBox();

        this.imgBg.attr({ y: (symbolBBox.y + symbolBBox.height) - bgSize.Height, height: bgSize.Height });

        this.bgLayerPosition = bgSize;
        this.bgLayerPosition.Height = this.bgLayerPosition.Height > 1 ? this.bgLayerPosition.Height : 1;
        //OLD BOETTO LOGIC
        // this.imgBg.attr({ height: bgSize.Height });
        // this.bgMatrix = this.bgMatrix || new Snap.Matrix();
        // this.bgMatrix.translate(0, bgSize.Y - this.bgLayerPosition.Y);
        // this.imgBg.transform(this.bgMatrix);
        // this.imgBg.remove();
        this.bgLayerPosition = bgSize;
    }
};

MODBUSSymbolValue.prototype.drawValueRect = function(){
    this.imgBg = this.wrapperGroup.rect(this.bgLayerPosition.X + 1, this.bgLayerPosition.Y, this.bgLayerPosition.Width - 2, this.bgLayerPosition.Height);
    this.imgBg.attr({ fill: this.foreColor || 'black' });
};
// noinspection JSUnusedGlobalSymbols
MODBUSSymbolValue.prototype.drawImg = function(img, valueBBox){
    var prevLayersImg;
    if(this.symbolIconElement){
        prevLayersImg = {
            img: this.symbolIconElement,
            bg: this.imgBg
        };
    }
    var bgSize = $.extend(true, {}, this.originalRectangle);
    bgSize.Height = bgSize.Height - valueBBox.height;
    bgSize.Height = bgSize.Height - this.drawOption.marginTop - this.drawOption.marginBottom;
    bgSize.Y = bgSize.Y + this.drawOption.marginTop;
    var value = Number(this.status);
    /** @namespace this.max */
    if(this.status > this.max){
        value = this.max;
    }
    /** @namespace this.min */
    var percentToColor = (Math.abs(this.min) + value) / (Math.abs(this.min) + this.max);
    percentToColor = percentToColor <= 1 ? percentToColor : 1;
    var offset = Math.floor(bgSize.Height * (1 - percentToColor));
    bgSize.Height -= offset;
    bgSize.Y += offset;
    this.bgLayerPosition = bgSize;
    this.bgLayerPosition.Height = this.bgLayerPosition.Height > 1 ? this.bgLayerPosition.Height : 1;
    this.drawValueRect();
    /** @namespace this.originalRectangle */
    this.symbolIconElement = this.wrapperGroup.image(img, this.originalRectangle.X, this.originalRectangle.Y, this.originalRectangle.Width, this.originalRectangle.Height - valueBBox.height);
    if(prevLayersImg){
        setTimeout(function(){
            prevLayersImg.img.remove();
            prevLayersImg.bg.remove();
        }, 1);
    }
};

// noinspection JSUnusedGlobalSymbols
MODBUSSymbolValue.prototype.getImage = function(){
    /** @namespace this.staticImageId */
    return this.imageShapeId ? this.imageBasePathURI + this.imageShapeId : null;
};

function MODBUSSymbolONOFF(){
    GEMSS.Symbol.apply(this, arguments);
}

MODBUSSymbolONOFF.prototype = new ModBusSymbol();
// noinspection JSUnusedGlobalSymbols
MODBUSSymbolONOFF.prototype.constructor = MODBUSSymbolONOFF;
// noinspection JSUnusedGlobalSymbols
MODBUSSymbolONOFF.prototype.getImage = function(){
    /** @namespace this.statusOFFImageId */
    /** @namespace this.statusONImageId */
    var img = this.onOffStatus ? this.statusONImageId : this.statusOFFImageId;
    /** @namespace this.imageBasePathURI */
    return img ? this.imageBasePathURI + img : null;
};

function WebBrowserSymbol(){
    GEMSS.Symbol.apply(this, arguments);
}



WebBrowserSymbol.prototype = new IconSymbol();
// noinspection JSUnusedGlobalSymbols
WebBrowserSymbol.prototype.constructor = WebBrowserSymbol;
WebBrowserSymbol.prototype.uber = IconSymbol.prototype;
// noinspection JSUnusedGlobalSymbols
WebBrowserSymbol.prototype.getImage = function(){
    /** @namespace this.iconFileId */
    return this.imageBasePathURI + this.iconFileId;
};
// noinspection JSUnusedGlobalSymbols
WebBrowserSymbol.prototype.draw = function(){
    /** @namespace this.MultiSelectionVisibleSymbolElement */
    this.uber.draw.call(this, this.MultiSelectionVisibleSymbolElement);
};

WebBrowserSymbol.prototype.openVideocloudPopup = function(){
        var streamVideocloudId = 1;
        if (this.gemssNodeInstance.r_symbolconfiguration.videoCloudChannelId && this.gemssNodeInstance.r_symbolconfiguration.videoCloudGUID != ""){
            streamVideocloudId = this.gemssNodeInstance.r_symbolconfiguration.videoCloudChannelId;
        }
        var that = this;
        setTimeout(function(){
            if(window.navigator.userAgent.indexOf("Safari") > -1 && window.navigator.userAgent.indexOf("Chrome") == -1){
                // console.log('è iOS');
                window.open(window.location.origin + window.location.pathname + '#!/error', '_blank', "width=500, height=500, top=50, left=100");
            }else{
                // console.log("non è iOS")
                window.open(window.location.origin + window.location.pathname + '#!/videocloud/'+ that.gemssNodeInstance.r_symbolconfiguration.videoCloudGUID + '/' + streamVideocloudId+'?name='+that.gemssNodeInstance.r_symbolconfiguration.description, '_blank', "width=500, height=500, top=50, left=100");
            }
            
        }, 1)

        return;

}
WebBrowserSymbol.prototype.changeState = function(newSymbol){
    // if (this.gemssNodeInstance.r_symbolconfiguration.videoCloudChannelId && this.gemssNodeInstance.r_symbolconfiguration.videoCloudGUID != ""){
    //     try {
    //         newSymbol.r_state == 'ALLARME|INCORSO'
    //         var that = this;
    //         this.mapControl.askForVideoPopupOpening(this.gemssNodeInstance.r_symbolconfiguration.description, function(){
    //             that.openVideocloudPopup();
    //         });
    //     } catch (err){
    //         console.error(err);
    //     }
    // }
    console.log('MC_WebBrowserSymbol.prototype.changeState')
}
WebBrowserSymbol.prototype.setContextMenu = function(){
    var that = this;
    /** @namespace this.menuVisible */
    if(this.menuVisible){
        this.symbolGroup.attr('cursor', 'pointer');
        this.symbolGroup.click(function(){
        });

        if(checkMobile()){
            // console.log('checkTouch');
            if(that.defaultCommand){
                $([that.symbolGroup.node]).click(function(){
                    that.mapControl.sendDefaultCommand(that);
                });
            } else if(that.delayClick) {
                that.delayClick();
            }else{
                that.setCommandPopupHandler();
            }
        }else{
            // console.log('onclickVST');
            if(this.defaultCommand){
                $([that.symbolGroup.node]).click(function(){
                    that.mapControl.sendDefaultCommand(that);
                });
            }
            if(!checkMobile() && checkTouchDevice()){
                // console.log('aggiunto comando per Touch');
                if(that.delayClick) {
                    that.delayClick();
                }else{
                    that.setCommandPopupHandler();
                }
            }
            $([that.symbolGroup.node]).contextMenu({
                menu: 'menuRect',
                menuOffset:that.menuOffset,
                onShow: function(){// TODO refactor
                    var $menu = $('#menuRect');
                    that.select();
                    $menu.empty();
                    var htmlEl = '<li><a href="#">Video Registrati</a></li>';
                    try {
                        if (that.gemssNodeInstance.r_symbolconfiguration.videoCloudHashSensor.length != 0){
                            htmlEl = '<li><a href="#">Video Registrati</a></li>';
                        } else {
                            htmlEl = '<li><a href="#">Video Registrati</a></li>';
                        }
                    } catch (err){

                    }
                    $menu.append(htmlEl);

                    $menu.find('A')
                        .mouseover(function(){
                            $menu.find('LI.hover').removeClass('hover');
                            $(this).parent().addClass('hover');
                        })
                        .mouseout(function(){
                            $menu.find('LI.hover').removeClass('hover');
                        })
                    //$menu.find('A').unbind('click');
                   .click(function(event){
                        console.log('CLICCK')
                        // event.preventDefault();
                        // event.stopPropagation();
                        $(this).parent().parent().find('.checked').removeClass('checked').end().find('a[checked="checked"]').removeAttr('checked');



                        that.deSelect();
                    });


                },
                onSelect: function(){
                    console.log("select");
                    $('.contextMenu').hide();
                    that.mapControl.askForVideoRecordings(that.gemssNodeInstance.r_symbolconfiguration.videoCloudGUID,
                        that.gemssNodeInstance.r_symbolconfiguration.videoCloudHashSensor,
                        that.installationId,
                        that.videoCloudPlantNumber,
                        that.videoCloudSensorsNumber );
                },
                fadeOut: function(){
                    that.highLighted = false;
                    that.draw();
                }
            });
        }
    }
};

WebBrowserSymbol.prototype.openVideoCludListDownload = function(){
    var that = this;
    that.mapControl.askForVideoRecordings(that.gemssNodeInstance.r_symbolconfiguration.videoCloudGUID,
        that.gemssNodeInstance.r_symbolconfiguration.videoCloudHashSensor,
        that.installationId,
        that.videoCloudPlantNumber,
        that.videoCloudSensorsNumber );
}

WebBrowserSymbol.prototype.onClickEvent = function(){
    //TODO insert in ad-hoc class
    /** @namespace this.uri */
    var targetUri = this.uri;
    if (this.gemssNodeInstance && this.gemssNodeInstance.r_symbolconfiguration.videoCloudGUID && this.gemssNodeInstance.r_symbolconfiguration.videoCloudGUID != ""){
        this.openVideocloudPopup();
    }
    /** @namespace this.parameters */
    var parameters = this.parameters;
    /** @namespace this.openInSamePage */
    var openInSamePage = this.openInSamePage;
    /** @namespace this.preAction */
    /** @namespace this.parameters */
    this.mapControl.$q.all(this.handlePreActions(this.preAction, this.parameters)).then(function(data){
        Object.keys(parameters).forEach(function(paramName){
            var paramValue = data[ paramName ] || parameters[ paramName ];
            targetUri = targetUri.replace('{' + paramName + '}', paramValue);
        });
        if(openInSamePage){
            window.location.href = targetUri;
        }else{
            window.open(targetUri, '_blank');
        }
    });
};
// noinspection JSUnusedGlobalSymbols
WebBrowserSymbol.prototype.setClickEvent = function(){
    var that = this;
    this.symbolGroup.attr('cursor', 'pointer');
    this.symbolGroup.click(function(){
        that.onClickEvent();
    });
    if (this.gemssNodeInstance && this.gemssNodeInstance.r_symbolconfiguration.videoCloudGUID && this.gemssNodeInstance.r_symbolconfiguration.videoCloudGUID != ""){
        this.setContextMenu();
    }
};
WebBrowserSymbol.prototype.handlePreActions = function(preActions, parameters){
    var promises = {};
    if(preActions.length > 0){
        if(preActions.includes('GET_TEBESMALL_TOKEN')){
            promises[ 'token' ] = this.mapControl.ViewPluginService.getTebeSmallToken(parameters.plantId);
        }
    }
    return promises;
};
WebBrowserSymbol.prototype.delayClick = function() {
    $([this.symbolGroup.node]).off('touchend');
    $([this.symbolGroup.node]).off('touchstart');

    var that = this;
    var timeoutId = null;
    $([that.symbolGroup.node]).on('touchstart', function() { 
        timeoutId = setTimeout(function() {
            that.openVideoCludListDownload();
        }, 1000);
    });
    $([that.symbolGroup.node]).on('touchend', function() {
        if(timeoutId !== null) clearInterval(timeoutId);
    });
}
function ViewsSymbol(){
    GEMSS.Symbol.apply(this, arguments);
}

ViewsSymbol.prototype = new IconSymbol();
// noinspection JSUnusedGlobalSymbols
ViewsSymbol.prototype.constructor = ViewsSymbol;
ViewsSymbol.prototype.uber = IconSymbol.prototype;
// noinspection JSUnusedGlobalSymbols
ViewsSymbol.prototype.getImage = function(){
    /** @namespace this.iconFileId */
    return this.imageBasePathURI + this.iconFileId;
};
ViewsSymbol.prototype.draw = function(){
    /** @namespace this.MultiSelectionVisibleSymbolElement */
    this.uber.draw.call(this, this.MultiSelectionVisibleSymbolElement);
};
ViewsSymbol.prototype.onClickEvent = function(){
     console.log(this);
    /** @namespace this.$state */
    var targetUri = this.$state.href('view', { //if without header is needed use standAloneView
        installationId: this.installationId,
        viewId: this.viewId,
        /** @namespace this.viewFilters */
        filters: btoa(unescape(encodeURIComponent(this.viewFilters)))
    });
    /** @namespace this.parameters */
    var parameters = this.parameters;
    /** @namespace this.openInSamePage */
    var openInSamePage = this.openInSamePage;
    /** @namespace this.parameters */
        if(openInSamePage){
            window.location.href = targetUri;
        }else{
            window.open(targetUri, '_blank');
        }
};
// noinspection JSUnusedGlobalSymbols
ViewsSymbol.prototype.setClickEvent = function(){
    var that = this;
    this.symbolGroup.attr('cursor', 'pointer');
    this.symbolGroup.click(function(){
        that.onClickEvent();
    });
};

function MapControl(htmlElement, backGroundImage, options){
    this.symbols = [];
    this.symbolsMap = {};
    this.linkSymbolsArray = [];
    this.selectedSymbols = [];
    this.paper = undefined;
    this.backGroundImage = undefined;
    this.imageGroup = undefined;
    // noinspection JSUnresolvedFunction
    this.paper = Snap(htmlElement);
    var s = this.paper.group();
    this.getCanvas = function(){
        return s;
    };
    s.attr({ id: 'graphic_1' });
    s.attr({ a: 'parent_el' });
    this.imageGroup = s.group();
    if(backGroundImage !== undefined){
        this.backGroundImage = this.imageGroup.image(backGroundImage);
    }
    if(options !== undefined){
        if(options.$q){
            this.$q = options.$q;
        }
        if(options.ViewPluginService){
            this.ViewPluginService = options.ViewPluginService;
        }
        if(options.$uibModal){
            this.$uibModal = options.$uibModal || {};
        }
        if(options.onNavigateEvent !== undefined){
            this.onNavigateEvent = options.onNavigateEvent;
        }
        if(options.onNavigateToMap !== undefined){
            this.onNavigateToMap = options.onNavigateToMap;
        }
        if(options.onGetCommand !== undefined){
            this.onGetCommand = options.onGetCommand;
        }
        if(options.onSendCommand !== undefined){
            this.onSendCommand = options.onSendCommand;
        }
        if(options.onPopupOpen !== undefined){
            this.onPopupOpen = options.onPopupOpen;
        }
        if(options.onCommandPopupOpen !== undefined){
            this.onCommandPopupOpen = options.onCommandPopupOpen;
        }
        if(options.getNodeData !== undefined){
            this.getNodeData = options.getNodeData;
        }
        if(options.sendPropertyListCommand !== undefined){
            this.sendPropertyListCommand = options.sendPropertyListCommand;
        }
        if(options.openChartModal !== undefined){
            this.openChartModal = options.openChartModal;
        }
        if(options.openTimeSlotModal!==undefined){
            this.openTimeSlotModal=options.openTimeSlotModal;
        }
        if(options.openTotalsModal !== undefined){
            this.openTotalsModal = options.openTotalsModal;
        }
        if(options.sendNoteListCommand !== undefined){
            this.sendNoteListCommand = options.sendNoteListCommand;
        }
        if(options.sendDefaultCommand !== undefined){
            this.sendDefaultCommand = options.sendDefaultCommand;
        }
    }
    this.askForVideoPopupOpening = function(descr, callback){
        return this.$uibModal.open({
            backdrop : false,
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'app/maps/askVideoModal/askVideoModal.tpl.html',
            controller: 'askVideoModalCtrl',
            resolve: {
                symbolDescription: function(){
                  return descr;
                },
                callback: function(){
                    return callback;
                }
            }
        });
    }

    this.askForVideoRecordings = function(videocloud, hashFilter, installationId,videoCloudPlantNumber,videoCloudSensorsNumber){
        if (!(installationId && videoCloudPlantNumber)){
            alert("simbolo senza associazione sensore video");
            return;
        }
        return this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'app/maps/videoFilesModal/videoChartModal.tpl.html',
            controller: 'videoChartModalCtrl',
            resolve: {
                sensorDescriptionRequest: function(){
                    return {
                        "installationId" : installationId,
                        "videoCloudPlantNumber" : videoCloudPlantNumber,
                        "videoCloudSensorsNumber" : videoCloudSensorsNumber
                    }
                },
                videocloudId: function(){
                    return videocloud;
                },
                hashFilter: function(){
                    return hashFilter;
                }
            }
        }).result.catch(function(res) {
            if (!(res === 'cancel' || res === 'escape key press' || res === 'backdrop click')) {
              throw res;
            }
          });
    }
    this.askForValue = function(options){
        return this.$uibModal.open({
            animation: true,
            templateUrl: 'app/shared/askValueModal/askValueModal.html',
            controller: 'askValueModalCtrl',
            resolve: {
                options: function(){
                    return options;
                }
            }
        });
    };

    this.getOptionForAppleMobile = function(optionName) {
        var bp = null;
        if(options.getBasePath) bp = options.getBasePath();
        if(!!bp) {
           // console.log('[gemss-map-getOptionForAppleMobile]:', optionName, bp[optionName] || 'not found');
            return bp[optionName] || false;
        } 
        //else { console.log('[gemss-map-getOptionForAppleMobile]:', optionName, 'not found'); }  
        return false; 
    }

    this.openPopupMap = function(guid, width, height, initSymbol){
        if(this.onPopupOpen !== undefined){
            this.onPopupOpen(guid, height, width, initSymbol);
        }
    };
    this.openCommandPopup = function(initSymbol, commands){
        if(this.onCommandPopupOpen !== undefined){
            return this.onCommandPopupOpen(initSymbol, commands);
        }
    };
    this.onSelectSymbol = function(sym){
        // TODO think about broadcast event
        for(var i = this.selectedSymbols.length - 1; i >= 0; i--){
            this.selectedSymbols[ i ].notifySelectionOnMap(sym);
        }
        this.selectedSymbols.push(sym);
    };
    this.deSelectSymbol = function(sym){
        for(var i = this.selectedSymbols.length - 1; i >= 0; i--){
            // noinspection EqualityComparisonWithCoercionJS
            if(this.selectedSymbols[ i ] == sym){
                this.selectedSymbols.splice(i, 1);
            }
        }
    };
    this.cleanMap = function(){
        var elements = s.selectAll('*');
        elements.forEach(function(el){
            el.remove();
        });
        if(window.hideContextMenu){
            window.hideContextMenu();
        }
        if(this.paper){
            var viewport = this.paper.select('.svg-pan-zoom_viewport');
            if(viewport){
                //viewport.attr();
            }
        }
        this.backGroundImage = undefined;
        this.imageGroup = s.group();
    };
    this.navigateMap = function(node){
        this.onNavigateEvent(node.guidLink, node.backGroundFileId, node);
    };
    this.navigateToGuid = function(node){
        /** @namespace node.pathLink */
        console.log(node);
        this.onNavigateToMap(node.guidLink);
    };
    this.getSymbolById = function(sId){
        return this.symbolsMap[ sId ];
    };
    this.updateSymbol = function(symbol){
        var toUpdateSymbol = this.symbolsMap[ symbol.symbolId ];
        if(toUpdateSymbol !== undefined){
            toUpdateSymbol.changeState(symbol);
            toUpdateSymbol.hydrate(symbol);
            toUpdateSymbol.draw();
        }
        for(var i = this.linkSymbolsArray.length - 1; i >= 0; i--){
            if(this.symbolLinkIsEqual(symbol, this.linkSymbolsArray[ i ])){
                this.linkSymbolsArray[ i ].changeState(symbol);
                this.linkSymbolsArray[ i ].hydrate(symbol);
                this.linkSymbolsArray[ i ].draw();
            }
        }
    };
    this.symbolLinkIsEqual = function(a, b){
        if(a === undefined || b === undefined){
            return false;
        }
        return a.symbolId === b.guidLink;
    };
    this.addSymbol = function(symbol){
        symbol.draw(s);
        this.symbols.push(symbol);
        this.symbolsMap[ symbol.symbolId ] = symbol;
        if(symbol instanceof LinkSymbol){
            this.linkSymbolsArray.push(symbol);
        }
        if(this.symbolsMap[ symbol.symbolId ].labelAlwaysVisibile && !this.symbolsMap[ symbol.symbolId ].isSymbol){
            this.symbolsMap[ symbol.symbolId ].toggleLabel();
        }
    };
    this.toggleLabel = function(){
        for(var i in this.symbols){
            try{
                // noinspection JSUnfilteredForInLoop
                var symbol=this.symbols[i];
                /** @namespace symbol.labelNeverVisible */
                if(!symbol.isLabelAlwaysVisible() && !symbol.labelNeverVisible){
                    symbol.toggleLabel();
                }
            }catch(Exception){

            }
        }
    };
    /**
     * Set Nodes Visibility
     * @param {[type]} nodesToShow guid  to be shown
     * @param {[type]} nodesToHide guid  to be hidden
     */
    this.setNodesVisibility = function(nodesToShow, nodesToHide){
        nodesToShow.forEach(function(nodeId){
            this.symbolsMap[ nodeId ].setVisibility(true);
        }, this);
        nodesToHide.forEach(function(nodeId){
            this.symbolsMap[ nodeId ].setVisibility(false);
        }, this);
    };
    this.setBackGroundURI = function(imageUri, callback){
        var that = this;
        if(this.backGroundImage === undefined){
            this.backGroundImage = this.imageGroup.image(imageUri);
        }
        var fakeImage = new Image();

        function noOp(){
        }

        function handleLoad(){
            fakeImage.onload = noOp();
            fakeImage.onerror = noOp();
            that.paper.node.setAttribute('height', '100%');
            that.backGroundImage.node.setAttribute('href', imageUri);
            if(callback){
                callback();
            }
        }

        function handleError(){
            fakeImage.onload = noOp();
            fakeImage.onerror = noOp();
            that.paper.node.setAttribute('height', '100%');
            //that.paper.node.setAttribute('viewBox', buildViewBoxStrFromObj(viewBoxObj));
            if(callback){
                callback();
            }
        }

        fakeImage.onload = handleLoad.bind();
        fakeImage.onerror = handleError.bind();
        fakeImage.src = imageUri;
    };
    this.getCommand = function(c, successClb){
        this.onGetCommand(c, successClb);
    };
    this.sendCommand = function(node, c){
        this.onSendCommand(node, c);
    };
}


function gemssMapDirective (MapService, $log, BASE_PATH, $uibModal, $rootScope, ViewPluginService, $state, $window, UserService, DRAW_OPTIONS, $q){
    return {
        templateUrl: 'app/maps/directives/gemss-map.tpl.html',
        restrict: 'AE',
        scope: {
            menuOffset:'@?',
            symbolHiglith: '=',
            node: '=',
            installationid: '='
        },
        link: function postLink(scope, element){
            var panZoomCfg;
            // noinspection SpellCheckingInspection
            console.log('creazione mobileEventHeandler');
            var mobileEventHandler = {
                haltEventListeners: ['touchstart', 'touchend', 'touchmove', 'touchleave', 'touchcancel','pointerenter', 'pointerdown', 'pointermove', 'pointerleave', 'pointercancel'],
                init: function(options){
                    var instance = options.instance;
                    var initialScale = 1;
                    var pannedX = 0;
                    var pannedY = 0;

                    // Init Hammer
                    // Listen only for pointer and touch events
                    /** @namespace Hammer.SUPPORT_POINTER_EVENTS */
                    /** @namespace Hammer */
                    /** @method destroy memberof Hammer */
                    /** @method on memberof Hammer */
                    this.hammer = Hammer(options.svgElement, {
                        inputClass: Hammer.SUPPORT_POINTER_EVENTS ? Hammer.PointerEventInput : Hammer.TouchInput
                    });
                    // console.log('creazione hammer', this.hammer);
                    // Enable pinch
                    this.hammer.get('pinch').set({ enable: true });
                    // Handle double tap
                    this.hammer.on('doubletap', function(){
                        instance.zoomIn();
                    });

                    // Handle pan
                    this.hammer.on('panstart panmove', function(ev){
                        // On pan start reset panned variables
                        if(ev.type === 'panstart'){
                            pannedX = 0;
                            pannedY = 0;
                        }
                        // Pan only the difference
                        instance.panBy({ x: ev.deltaX - pannedX, y: ev.deltaY - pannedY });
                        pannedX = ev.deltaX;
                        pannedY = ev.deltaY;
                    });
                    // Handle pinch
                    this.hammer.on('pinchstart pinchmove', function(ev){
                        // On pinch start remember initial zoom
                        if(ev.type === 'pinchstart'){
                            initialScale = instance.getZoom();
                            instance.zoom(initialScale * ev.scale);
                        }
                        instance.zoom(initialScale * ev.scale);
                    });
                    // Prevent moving the page on some devices when panning over SVG
                    options.svgElement.addEventListener('touchmove', function(e){
                        e.preventDefault();
                    });
                }, destroy: function(){
                    this.hammer.destroy();
                }
            };
            panZoomCfg = {
                zoomEnabled: true,
                controlIconsEnabled: false,
                fit: true,
                center: true
            };
            var beforePan = function(oldPan, newPan){
                var gutterWidth = 10;
                var gutterHeight = 10;
                // Computed variables
                var sizes = this.getSizes();
                var leftLimit = -((sizes.viewBox.x + sizes.viewBox.width) * sizes.realZoom) + gutterWidth;
                var rightLimit = sizes.width - gutterWidth - (sizes.viewBox.x * sizes.realZoom);
                var topLimit = -((sizes.viewBox.y + sizes.viewBox.height) * sizes.realZoom) + gutterHeight;
                var bottomLimit = sizes.height - gutterHeight - (sizes.viewBox.y * sizes.realZoom);
                var customPan = {};
                customPan.x = Math.max(leftLimit, Math.min(rightLimit, newPan.x));
                customPan.y = Math.max(topLimit, Math.min(bottomLimit, newPan.y));
                return customPan;
            };
            var symbolIsOfGivenType = function(symbolType, type){
                return symbolType.indexOf(type) !== -1;
            };
            var addSymbols = function(symbols, mapControl, layerNode){
                symbols.map(function(node){
                    var symbolInstance;
                    var symbolData = Object.create(node.r_symbolconfiguration);

                    function handleModBusSymbol(nodeType, mapControl, layerNode){
                        var instance;
                        switch(true){
                            case symbolIsOfGivenType(nodeType, 'MODBUSSymbolONOFF'):
                                return new MODBUSSymbolONOFF(mapControl, layerNode);
                            case symbolIsOfGivenType(nodeType, 'MODBUSSymbolValueStatic'): //must be before the next one
                                return new MODBUSSymbolValueStatic(mapControl, layerNode);
                            case symbolIsOfGivenType(nodeType, 'MODBUSSymbolValue'):
                                return new MODBUSSymbolValue(mapControl, layerNode);
                            default:
                                instance = new ModBusSymbol(mapControl, layerNode);
                                instance.guidLink = node.r_idsymbol;
                        }
                        return instance;
                    }

                    switch(true){
                        case symbolIsOfGivenType(node.r_symbolconfiguration.$type, 'Antintrusion'):
                            symbolInstance = new AntintrusionSymbol(mapControl, layerNode);
                            break;
                        case symbolIsOfGivenType(node.r_symbolconfiguration.$type, 'Label'):
                            symbolInstance = new LabelSymbol(mapControl, layerNode);
                            break;
                        case symbolIsOfGivenType(node.r_symbolconfiguration.$type, 'Link'):
                            symbolInstance = new LinkSymbol(mapControl, layerNode);
                            break;
                        case symbolIsOfGivenType(node.r_symbolconfiguration.$type, '.LayerSymbol'):
                            symbolInstance = new LayerSymbol(mapControl, layerNode);
                            break;
                        case symbolIsOfGivenType(node.r_symbolconfiguration.$type, 'MultiSelectionVisibleSymbol'):
                            symbolInstance = new MultiSelectionVisibleSymbol(mapControl, layerNode);
                            break;
                        case symbolIsOfGivenType(node.r_symbolconfiguration.$type, 'MODBUSSMOWKE'):
                            symbolInstance = handleModBusSymbol(node.r_symbolconfiguration.$type, mapControl, layerNode);
                            break;
                        case symbolIsOfGivenType(node.r_symbolconfiguration.$type, 'WebBrowserSymbol'):
                            symbolInstance = new WebBrowserSymbol(mapControl, layerNode);
                            break;
                        case symbolIsOfGivenType(node.r_symbolconfiguration.$type,'ViewSymbol'):
                            symbolInstance = new ViewsSymbol(mapControl, layerNode);
                            break;
                        default:
                            symbolInstance = new GEMSS.Symbol(mapControl, layerNode);
                            symbolInstance.guidLink = node.r_idsymbol;
                            break;
                    }
                        symbolData.gemssSymbolData = node.r_symbolconfiguration;
                    symbolData.gemssNodeInstance = node;
                    symbolData.menuOffset=scope.menuOffset;
                    symbolData.image = { Data: BASE_PATH.MEDIA_PATH + 'image/' };
                    symbolData.imageBasePathURI = BASE_PATH.MEDIA_PATH + 'gemss/installation/' + scope.installationid + '/icon/';
                    symbolData.symbolId = node.r_idsymbol;
                    symbolData.status = node.r_state;
                    symbolData.command = node.r_command;
                    symbolData.layer = layerNode;
                    symbolData.description = node.r_symbolconfiguration.description;
                    symbolData.labelPosition = node.r_symbolconfiguration.labelPosition;
                    symbolData.backColor = node.r_symbolconfiguration.backColor;
                    /** @namespace node.r_symbolconfiguration.foreColor */
                    symbolData.foreColor = node.r_symbolconfiguration.foreColor;
                    symbolData.alignment = node.r_symbolconfiguration.alignment;
                    /** @namespace node.r_symbolconfiguration.labelAlwaysVisibile */
                    symbolData.labelAlwaysVisible = node.r_symbolconfiguration.labelAlwaysVisibile;
                    symbolData.drawOption = node.r_symbolconfiguration.drawOption ? node.r_symbolconfiguration.drawOption : DRAW_OPTIONS;
                    symbolData.drawOption = symbolData.drawOption ? symbolData.drawOption : {
                        marginTop: 0,
                        marginBottom: 0
                    };
                    symbolData.drawOption.marginTop = symbolData.drawOption.marginTop || 0;
                    symbolData.drawOption.marginBottom = symbolData.drawOption.marginBottom || 0;
                    /** @namespace scope.symbolHiglith */
                    symbolData.highLighted = symbolData.symbolId === scope.symbolHiglith;
                    symbolData.preAction = node.r_symbolconfiguration.preAction;
                    symbolData.openInSamePage = node.r_symbolconfiguration.openInSamePage||true; //TODO valutare se rendere configurabile tramite hicloud configurator
                    symbolData.parameters = node.r_symbolconfiguration.parameters;
                    symbolData.uri = node.r_symbolconfiguration.uri;
                    symbolData.$state=$state;
                    symbolData.viewFilters=node.r_symbolconfiguration.viewFilters;
                    symbolData.installationId=scope.installationid;
                    if(angular.isString(symbolData.preAction)){
                        try{
                            symbolData.preAction = angular.fromJson(symbolData.preAction);
                        }catch(e){
                            symbolData.preAction = [symbolData.preAction];
                        }
                    }
                    if(angular.isString(symbolData.parameters)){
                        try{
                            symbolData.parameters = angular.fromJson(symbolData.parameters);
                        }catch(e){
                            symbolData.parameters = {};
                        }
                    }
                    //$log.debug(symbolInstance);
                    symbolInstance.hydrate(symbolData);
                    // implicit Draw on symbol
                    mapControl.addSymbol(symbolInstance);
                });
            };
            var getNode = function(nodeId, layerNode){
                return MapService.map.getNodeSymbols(scope.installationid, nodeId).then(function(nodeData){
                    addSymbols(nodeData.children, mapControl, layerNode);
                    return nodeData;
                });
            };

            var getBasePath = function() {
                return BASE_PATH;
            };
            
            var svgElement = element.find('svg')[ 0 ];

            function onResizeHandler(){
                if(scope.panZoom){
                    // noinspection JSUnresolvedFunction
                    scope.panZoom.resize();
                    // noinspection JSUnresolvedFunction
                    scope.panZoom.fit();
                    // noinspection JSUnresolvedFunction
                    scope.panZoom.center();
                }
            }

            var reloadMap = function(r_idsymbol, backGroundFileId){
                $log.info('reloadMap');
                mapControl.cleanMap();
                if(scope.panZoom){
                    scope.panZoom.destroy();
                    delete scope.panZoom;
                }
                var backgroundImageURI = BASE_PATH.MEDIA_PATH + 'gemss/installation/' + scope.installationid + '/map/' + backGroundFileId;
                var nodes = scope.node.children;
                mapControl.setBackGroundURI(backgroundImageURI, function(){
                    if(angular.isUndefined(nodes) || nodes.length === 0){
                        scope.noChildrenWarning = true;
                    }else{
                        scope.noChildrenWarning = false;
                        addSymbols(nodes, mapControl);
                    }
                    if(!scope.panZoom){
                        if(checkMobile()){
                            // console.log('checkTouch');
                            panZoomCfg.customEventsHandler = mobileEventHandler;
                        }else{
                            // console.log('Hammer.SUPPORT_POINTER_EVENTS',Hammer.SUPPORT_POINTER_EVENTS)
                            // console.log('onclickVST');
                            if(!checkMobile() && checkTouchDevice()){
                                // console.log('aggiunto comando per Touch');
                                panZoomCfg.customEventsHandler = mobileEventHandler;
                            }
                            if(!UserService.mapCanBeZoomed(scope.installationid)){
                                panZoomCfg.zoomEnabled = false;
                                panZoomCfg.dblClickZoomEnabled = false;
                            }
                            if(!UserService.mapCanBePanned(scope.installationid)){
                                panZoomCfg.panEnabled = false;
                            }
                        }
                        scope.panZoom = svgPanZoom(svgElement, panZoomCfg);
                        // noinspection JSUnresolvedFunction,JSCheckFunctionSignatures
                        scope.panZoom.setBeforePan(beforePan);
                        // noinspection SpellCheckingInspection
                        window.onresize = onResizeHandler.bind();
                    }
                });
            };
            var onNavigateMapEvent = function(id, backgroundId, node, hierarchy){
                $log.info('onNavigateMapEvent', { nodeId: id, nodeMapInstance: node, hierarchy: hierarchy });
                $rootScope.$emit('map:navigate', { nodeId: id, nodeMapInstance: node, hierarchy: hierarchy });
            };

            function onOpenPopupMapFn(guid, height, width, initSymbol){
                var url = $state.href('standAloneMap', {
                    installationId: scope.installationid,
                    mapId: initSymbol.symbolId
                });
                var specs = [];
                if(width && width > 0){
                    specs.push('width=' + width);
                }
                if(height && height > 0){
                    specs.push('height=' + height);
                }
                specs.push('top=20');//order is important
                $window.open(url, '_blank', specs.join(','));
            }

            function onOpenCommandPopupFn(cmdSymbol, commands){
                return $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    templateUrl: 'app/maps/commandPopup/commandPopup.tpl.html',
                    controller: 'MapCommandPopupCtrl',
                    resolve: {
                        symbol: function(){
                            return cmdSymbol;
                        },
                        commands: function(){
                            return commands;
                        }
                    }
                });
            }

            function sendNoteListCommand(symbol, commandList){
                ViewPluginService.getNoteList(commandList, scope.installationid).then(function(data){
                    var modalInstance = $uibModal.open({
                        animation: true,
                        ariaLabelledBy: 'modal-title',
                        ariaDescribedBy: 'modal-body',
                        templateUrl: 'app/maps/NoteMapPopup/NoteMapPopup.tpl.html',
                        controller: 'MapNotePopupCtrl',
                        resolve: {
                            symbol: function(){
                                return symbol;
                            },
                            properties: function(){
                                return data;
                            }
                        }
                    });
                    modalInstance.result.then(function(selectedItem){
                    }, function(){
                        $log.info('Modal dismissed at: ' + new Date());
                    });
                    return modalInstance;
                }, function(error){
                    $log.error(error);
                });
            }

            function sendPropertyListCommand(symbol, commandList){
                ViewPluginService.getPropertyList(commandList, scope.installationid).then(function(data){
                    var modalInstance = $uibModal.open({
                        animation: true,
                        ariaLabelledBy: 'modal-title',
                        ariaDescribedBy: 'modal-body',
                        templateUrl: 'app/maps/propertyMapPopup/propertyMapPopup.tpl.html',
                        controller: 'MapPropertyPopupCtrl',
                        resolve: {
                            symbol: function(){
                                return symbol;
                            },
                            properties: function(){
                                return data;
                            }
                        }
                    });
                    modalInstance.result.then(function(selectedItem){
                    }, function(){
                        $log.info('Modal dismissed at: ' + new Date());
                    });
                    return modalInstance;
                }, function(){
                });
            }

            function openChartModalFn(symbol,command){
                return $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    templateUrl: 'app/maps/chartModal/chartModal.tpl.html',
                    controller: 'ChartModalCtrl',
                    //windowClass:'modal-xlg',
                    size: 'lg',
                    resolve: {
                        command:function(){
                            return command;
                        },
                        symbol: function(){
                            return symbol;
                        },
                        installationId: function(){
                            return scope.installationid;
                        }
                    }
                });
            }

            function openTotalsModalFn(symbol,command){
                return $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    templateUrl: 'app/maps/totalsModal/totalsModal.tpl.html',
                    controller: 'TotalsModalCtrl',
                    //windowClass:'modal-xlg',
                    size: 'lg',
                    resolve: {
                        command:function(){
                            return command;
                        },
                        symbol: function(){
                            return symbol;
                        },
                        installationId: function(){
                            return scope.installationid;
                        }
                    }
                });
            }

            function onNavigateToMap(mapId){
                console.log({ installationId: scope.installationid, mapId: mapId });
                $state.go('map', { installationId: scope.installationid, mapId: mapId }, { reload: true });
            }

            scope.getCommand = function(commandId, successClb){
                ViewPluginService.getCommand(commandId, scope.installationid).then(function(data){
                    successClb(data);
                }, function(error){
                    $log.error(error);
                });

            };
            scope.sendCommand = function(item, command){
                var destinationRole = command[ 'r_worker' ];
                var plantId = item[ 'r_idplant' ];
                if(angular.isDefined(plantId)){
                    $log.info('send command', command[ 'r_protocol' ], plantId);
                    var addInfo = { 'PLANT_DESCRIPTION': command[ 'r_plantdescription' ] };
                    return ViewPluginService.sendCommand(command[ 'r_protocol' ], plantId, destinationRole, scope.installationid, addInfo);
                }else{
                    throw new Error('no plantid for item command');
                }
            };
            scope.sendDefaultCommand = function(symbol){
                ViewPluginService.sendDefaultCommand(symbol.command, scope.installationid, symbol.gemssNodeInstance.r_idplant);
            };

            function openTimeSlotModal(symbol, command){
                return $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    templateUrl: 'app/maps/TimeSlotcommandPopup/commandPopup.tpl.html', // MD, 12/01/2021 --> C'era uno spazio prima di commandPopup.tpl.html
                    controller: 'TimeSlotCommandPopupCtrl',
                    size: 'lg',
                    resolve: {
                        command: function () {
                            return command;
                        },
                        symbol: function () {
                            return symbol;
                        },
                        installationId: function () {
                            return scope.installationid;
                        },
                        sendMsgFn:function () {
                            return scope.sendCommand;
                        }
                    }
                });
            };

            var mapControl = new MapControl(svgElement, undefined, {
                openTimeSlotModal: openTimeSlotModal,
                'onNavigateEvent': onNavigateMapEvent,
                'onNavigateToMap': onNavigateToMap,
                'onGetCommand': scope.getCommand,
                'onSendCommand': scope.sendCommand,
                'onPopupOpen': onOpenPopupMapFn,
                'onCommandPopupOpen': onOpenCommandPopupFn,
                'sendPropertyListCommand': sendPropertyListCommand,
                'sendNoteListCommand': sendNoteListCommand,
                'getNodeData': getNode,
                'getBasePath': getBasePath || null,
                $q: $q,
                ViewPluginService: ViewPluginService,
                openChartModal: openChartModalFn,
                openTotalsModal: openTotalsModalFn,
                sendDefaultCommand: scope.sendDefaultCommand,
                $uibModal: $uibModal
            });

            scope.toggleLabel = function(){
                mapControl.toggleLabel();
            };
            scope.$watch('node', function(){
                $log.debug('node changed in gemss map directive');
                if(angular.isUndefined(scope.node)){
                    return;
                }
                if(scope.node.r_idsymbol){
                    reloadMap(scope.node.r_idsymbol, scope.node.r_symbolconfiguration.backGroundFileId, scope.installationid);
                }else{
                    reloadMap(scope.node.guidLink, scope.node.backGroundFileId, scope.installationid);
                }
            });
            var resizeListener = $rootScope.$on('map:resize', function(){
                onResizeHandler();
            });

            //metodo che ricarica la mappa al cambio di dimensione dello schermo non funziona
            // $(window).resize(function() {
            //     console.log('window was resized!');
            //     reloadMap();
            // });

            scope.testEvent = function(){


                mapControl.updateSymbol({
                    symbolId: "99ade997-8182-4a51-b559-c8719ab5e83e",
                    status: "ALLARME|INCORSO",
                    command: "nodeData.r_command"
                });
            };
            /**
             *
             * @param event
             * @param payload<object>
             */
            function socketMapListener(event, payload){
                $log.info('received map event');
                var symbolsData = payload.data || [];
                for(var i = 0; i < symbolsData.length; i++){
                    var symbolData = {};
                    /** @namespace scope.IdSymbol */
                    symbolData.symbolId = symbolsData[ i ].IdSymbol;
                    symbolData.status = symbolsData[ i ].State;
                    /** @namespace scope.Command */
                    symbolData.command = symbolsData[ i ].Command;
                    mapControl.updateSymbol(symbolData);
                }
            }
            var socketListener = $rootScope.$on('socket:map', socketMapListener);
            var socketListenerRefresh = $rootScope.$on('socket:refresh', function(){
                /** @namespace scope.installationid */
                MapService.map.getNodeSymbols(scope.installationid, scope.node.r_idsymbol).then(function(nodeData){
                    mapControl.updateSymbol({
                        symbolId: nodeData.r_idsymbol,
                        status: nodeData.r_state,
                        command: nodeData.r_command
                    });
                    nodeData.children = nodeData.children || [];
                    nodeData.children.forEach(function(item){
                        mapControl.updateSymbol({
                            symbolId: item.r_idsymbol,
                            status: item.r_state,
                            command: item.r_command
                        });
                    });
                });
            });

            function mapSelectionNodeListener (event, payload){
                /** @namespace payload.r_idsymbol */
                mapControl.getSymbolById(payload.r_idsymbol).select();
            }
            var selectListener = $rootScope.$on('map:selectnode',mapSelectionNodeListener);
            scope.$on('$destroy', function(){
                socketListener();
                selectListener();
                resizeListener();
                socketListenerRefresh();
            });
        }
    };
}

// noinspection JSValidateTypes
angular.module('maps').directive('gemssmap',gemssMapDirective);
